import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getEvents } from './selector';

export const useRegistrationOptions = (eventId: string) => {
  const events = useSelector(getEvents);
  const foundEvent = useMemo(() => {
    if (events) {
      const event = events.find((event) => event._id === eventId);

      return event;
    }
  }, [events, eventId]);

  return {
    event: foundEvent,
    paymentRules: foundEvent?.paymentRules,
    registrationOptions: foundEvent?.registrationOptions
  };
};
